import { useContext } from 'react';
import { TenantActionsContext, type TenantActionsValue } from './tenantActions';

const NONE: TenantActionsValue = { tenantId: null, actions: new Set() };

/** What the reader may do in the tenant the app is showing; nothing outside the shell. */
export function useTenantActions(): TenantActionsValue {
  return useContext(TenantActionsContext) ?? NONE;
}
